import { Form } from 'components/Form/base/Form';
import { FormInput } from 'components/Form/next';
import Loader from 'components/Loader';
import { useState } from 'react';
import useSWR from 'swr';
import { useApi } from '~/hooks/useApi';
import { Selection } from '../DataTable';
import { FilterState } from '../DataTable/DataTable';

interface Props {
    selection: Selection;
    filter: FilterState;
    clubSlug: string;
    callback?: () => void;
    eventId?: number;
    variant: 'members' | 'bookers' | 'allocation';
}

export const MultiSubscribeToNewsletter = ({ selection, clubSlug, callback, variant, filter, eventId }: Props) => {
    const { data: contentGroupsOptions, isLoading: isLoadingContentGroups } = useSWR(`club/${clubSlug}/content-group`);
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const options = contentGroupsOptions?.data;

    const handleSubscribe = (content_group: any) => {
        let apiUrl = '';
        switch (variant) {
            case 'members':
                apiUrl = `club/${clubSlug}/subscriber/members`;
                break;
            case 'bookers':
                apiUrl = `club/${clubSlug}/subscriber/bookers`;
                break;
            case 'allocation':
                apiUrl = `club/${clubSlug}/subscriber/allocations`;
                break;

            default:
                break;
        }

        return api({
            url: apiUrl,
            method: 'POST',
            data: {
                ...content_group,
                selection,
                filter,
                event_id: eventId
            },
            onBefore: () => {
                setIsLoading(false);
            },
            onSuccess: () => {
                callback();
            }
        });
    };

    return (
        <Loader isLoading={isLoadingContentGroups}>
            <Form onSubmit={handleSubscribe}>
                <FormInput.Select
                    options={
                        options?.map((contentGroups) => ({
                            key: contentGroups.id,
                            label: contentGroups.title
                        })) ?? []
                    }
                    name="content_group_id"
                    label="Zielgruppe"
                />
                <FormInput.Submit isLoading={isLoading}>Alle Benutzer anmelden </FormInput.Submit>
            </Form>
        </Loader>
    );
};

export default MultiSubscribeToNewsletter;
